import createSvgIcon from "./utils/create_icon"

const ArrowLeft = createSvgIcon(<path d="M10.707 9.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L9.414 13H17a1 1 0 1 0 0-2H9.414z" fill="currentColor" />, "ArrowLeft")
export default ArrowLeft
